import React from 'react';
import { Box, Skeleton } from '@mui/material';

const ProductDetailsSkeleton: React.FC = () => (
  <Box sx={{ width: '100%' }}>
    <Skeleton variant="rectangular" height={120} sx={{ mb: 2 }} />
    <Skeleton variant="text" height={40} width="70%" sx={{ mb: 1 }} />
    <Skeleton variant="text" height={30} width="50%" sx={{ mb: 2 }} />
    <Skeleton variant="rectangular" height={200} sx={{ mb: 2 }} />
  </Box>
);

export default ProductDetailsSkeleton;
